import AccessibleIcon from "@mui/icons-material/Accessible";
import AddIcon from "@mui/icons-material/Add";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import FastfoodIcon from "@mui/icons-material/Fastfood";
import FlagIcon from "@mui/icons-material/Flag";
import FlareIcon from "@mui/icons-material/Flare";
import InfoIcon from "@mui/icons-material/Info";
import LanguageIcon from "@mui/icons-material/Language";
import PeopleIcon from "@mui/icons-material/People";
import StyleIcon from "@mui/icons-material/Style";
import UpdateIcon from "@mui/icons-material/Update";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import { SvgIconProps } from "@mui/material";
import { styled } from "@mui/material/styles";
import capitalize from "lodash/capitalize";
import groupBy from "lodash/groupBy";
import { ComponentType } from "react";

import { ProductAttributeListNode } from "../../apiHooks/useProduct";
import { LabelValue } from "../../components/LabelValue";

export type ProductAttributesMetaDataProps = {
    attributes: ProductAttributeListNode[];
};

const Wrapper = styled(LabelValue)({
    maxWidth: 300,
});

export function ProductAttributesMetaData({ attributes }: ProductAttributesMetaDataProps) {
    const finalAttributes = computeAttributes(attributes);

    return (
        <>
            {finalAttributes.map(({ label, icon: Icon, names }) => {
                const value = names.join(", ");
                return (
                    <Wrapper label={label} key={label} Icon={Icon}>
                        {value}
                    </Wrapper>
                );
            })}
        </>
    );
}

const ATTRIBUTES_ICONS_BY_LEVEL: Record<string, ComponentType<SvgIconProps> | undefined> = {
    Style: StyleIcon,
    "Traveler Type": PeopleIcon,
    "Time Required": UpdateIcon,
    "Season / Occasion": WbSunnyIcon,
    Language: LanguageIcon,
    "Added Extras": AddIcon,
    "Food and Drink Included ____": FastfoodIcon,
    Accessibility: AccessibleIcon,
    Transport: DirectionsCarIcon,
    "Good To Know": InfoIcon,
    "Meeting Type": FlagIcon,
};

function computeAttributes(
    attributes: ProductAttributeListNode[]
): Array<{ label: string; names: string[]; icon: ComponentType<SvgIconProps> }> {
    const attributesByLevel1 = groupBy(attributes, "level1");

    return Object.entries(attributesByLevel1).map(([level1, attributes]) => {
        const names = attributes.map(({ name }) => `${capitalize(name ?? "")}`);
        const icon = ATTRIBUTES_ICONS_BY_LEVEL[level1] ?? FlareIcon;

        return {
            label: level1,
            names,
            icon,
        };
    });
}
